import {useMemo} from "react";
import {dataSustainabilityScorecard} from "../../data/data-sustainability-scorecard";
import styles from "./SustainabilityScorecard.module.scss";
import { formatNumberWithDot } from '../../utils/utils';
import {useIsMobile} from "../../hooks/mobile";

import IconSDG from '../common/icon/icon-sdg';
import IconTier from '../common/icon/icon-tier';
import IconWealth from '../common/icon/icon-wealth';
import IconEmissions from '../common/icon/icon-emissions';
import IconPopulation from '../common/icon/icon-population';


const SCORES = [
    {
        key: "indexScore",
        name: "2023 SDG Index score*",
        icon: IconSDG
    },
    {
        key: "tier",
        name: "Wealth tier**",
        icon: IconTier
    },
    {
        key: "wealth",
        name: "Wealth per capita (USD)**",
        icon: IconWealth
    },
    {
      key: "population",
      name: "Population density (people/km²)***",
      icon: IconPopulation
    },
    {
        key: "co2",
        name: "CO₂ emissions per capita (%)***",
        icon: IconEmissions
    }
]

export default function SustainabilityScorecard(props) {
    const {iso} = props;
    const isMobile = useIsMobile();
    const ICON_SIZE = isMobile ? 30 : 36;
    const data = useMemo(() => {
        // find dataset based on the iso
        const result = dataSustainabilityScorecard.find((d) => d.iso.toLowerCase() === iso.toLowerCase())
        if (!result) {
            return null;
        }
        return result;
    }, [iso])

    return (
        <div className={styles.sustainabilityScorecard}>
            {data && (
                <table className={styles.sustainabilityScorecardTable}>
                    <thead>
                    <tr className={styles.sustainabilityScorecardTableHead}>
                        {/* <th colSpan={isMobile ? 2 : 3}> */}
                        <th colSpan={2}>
                          <h3
                            className={styles.sustainabilityScorecardTableHeader}>{ data.country }</h3>
                        </th>
                        {/* <th className={styles.percentage}>
                            <span className={styles.sustainabilityScorecardTableHeaderScore}>Percentage</span>
                            <h3 className={styles.sustainabilityScorecardTableHeaderH3}>{(data.totalPercentage *100).toFixed(2)}%</h3>
                        </th> */}
                        {/* <th colSpan={isMobile ? 2 : 1} className={styles.totalScore}> */}
                        {/* <th colSpan={2} className={styles.totalScore}>
                            <span className={styles.sustainabilityScorecardTableHeaderScore}>Score <span className={styles.outOf60}>(Out of 60)</span></span>
                            <h3 className={styles.sustainabilityScorecardTableHeaderH3}>{data.indexScore}</h3>
                        </th> */}
                        <th colSpan={2} ><></></th>
                    </tr>
                    </thead>
                    <tbody>
                    {data && SCORES.map((score) => {
                        const IconComponent = score.icon;
                        return (
                            <tr key={score.key}>
                                <td aria-hidden="true" className={styles.iconColumn}>
                                    <IconComponent alt={data[score.key]} className={styles.parameterIcon}
                                                   style={{height: "auto", width: ICON_SIZE}} aria-hidden="true"/>
                                </td>
                                <td className={styles.nameColumn}>{score.name}</td>
                                {/* <td colSpan={2} className={styles.barchartColumn}>
                                    <div className={styles.barchartBackground}></div>
                                    <div className={styles.barchartForeground}
                                         style={{width: `${data[score.key] * 10}%`}}></div>
                                    <div className={styles.barChartLabel}>{score.name}</div>
                                </td> */}
                                <td className={styles.scoreColumn}>{formatNumberWithDot(data[score.key]) + (score.key === 'co2' ? '%' : '')}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            )}
            <div className="footer-note my-5">
              <p>Sources: <sup>∗</sup>Sustainable Development Report 2023 <a href="https://doi.org/10.25546/102924">doi.org/10.25546/102924</a>; <sup>∗∗</sup>New World Wealth; <sup>∗∗∗</sup>World Bank</p>
            </div>
        </div>
    );
}
